
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["oeamtc-listitem__icon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#fff","d":"M8 1a7 7 0 107 7 7 7 0 00-7-7zm5 7a5 5 0 01-.83 2.75L5.25 3.83A5 5 0 0113 8zM3 8a5 5 0 01.83-2.75l6.92 6.92A5 5 0 013 8z"}})])
          )
        }
      }
    